import { create } from 'zustand';

/**
 * Centrale store voor open/close state van alle klacht-dialogs.
 * Eén store i.p.v. één per dialog: voorkomt dat elke pagina zijn eigen
 * dialog-mounts moet beheren. App.tsx mount alle dialogs op een hoog niveau
 * en elke dialog leest hier zijn eigen open-state via `useKlachtDialogStore`.
 */
export type KlachtDialogType =
  | 'register'
  | 'status'
  | 'close'
  | 'addRefund'
  | 'addNewWo'
  | 'addInvoice'
  | 'addCoulance'
  | 'addNoAction';

export interface KlachtDialogPayload {
  /** Klacht waarop een action wordt toegevoegd of die wordt geüpdatet. */
  klachtId?: string;
  /** Originele werkorder — bron voor pickers (vervolg-WO items, factuur-regels). */
  werkOrderId?: string;
  /** Order-nummer voor weergave in dialog-header. */
  werkOrderNummer?: string;
  /** Vooringevulde nieuwe status voor `KlachtStatusDialog` (bv. 'Wacht_op_Klant'). */
  newStatus?: string;
  /** Vrije extra context die een dialog nodig heeft. */
  extra?: Record<string, unknown>;
}

interface KlachtDialogState {
  openDialog: KlachtDialogType | null;
  payload: KlachtDialogPayload;
  open: (dialog: KlachtDialogType, payload?: KlachtDialogPayload) => void;
  close: () => void;
}

export const useKlachtDialogStore = create<KlachtDialogState>((set) => ({
  openDialog: null,
  payload: {},
  open: (dialog, payload = {}) => set({ openDialog: dialog, payload }),
  close: () => set({ openDialog: null, payload: {} }),
}));
